<template>
  <section class="article-video">
    <div v-if="isSingleVideo">
     <div class="article-video__player">
       <module-player :video-id="singleVideo._id" />
     </div>
      <figcaption>
        <div class="article__rectangle"></div>
        <div class="article__image-title">{{ singleVideo?.title }}</div>
      </figcaption>
    </div>
  </section>
</template>

<script setup>
import {computed} from "vue";
import ModulePlayer from "@/components/modules/ModulePlayer.vue";

const isSingleVideo = computed(() => props.context.length === 1)
const singleVideo = computed(() => props.context[0])
const multipleVideo = computed(() => props.context.length > 1)

const props = defineProps({
  context: {
    type: Object,
    default: () => ({})
  },
})
</script>

<style lang="scss">
@import '@/assets/scss/components/article/article-video.scss';
</style>
